import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23708 23827"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528317065472">
        <path
          d="M21847 21162H1862c-124 0-223-100-223-223V223c0-123 99-223 223-223h19985c123 0 222 100 222 223v20716c0 123-99 223-222 223zm-19762-446h19536V446H2085v20270z"
          className="fil0"
        />
        <path
          d="M23485 23827H223c-123 0-223-100-223-223v-2665c0-124 100-223 223-223h23262c124 0 223 99 223 223v2665c0 123-99 223-223 223zM446 23381h22816v-2219H446v2219zM18330 19337H5376c-35 0-68-8-100-24l-2823-1394c-94-46-143-150-118-250 24-99 112-172 217-172h18602c104 0 193 73 217 172 24 102-27 204-118 250l-2824 1394c-29 16-64 24-99 24zm-12901-446h12850l1921-948H3508l1921 948z"
          className="fil0"
        />
        <path
          d="M7447 17943H5838c-124 0-223-99-223-223v-967c0-123 99-223 223-223h1609c124 0 223 100 223 223v967c0 124-99 223-223 223zm-1386-446h1163v-521H6061v521zM17870 17943h-1609c-123 0-223-99-223-223v-967c0-123 100-223 223-223h1609c124 0 224 100 224 223v967c0 124-100 223-224 223zm-1386-446h1163v-521h-1163v521z"
          className="fil0"
        />
        <path
          d="M18330 16976H5376c-35 0-68-8-100-24l-2823-1395c-94-45-143-150-118-249 24-102 112-172 217-172h18602c104 0 193 72 217 172 24 102-27 204-118 249l-2824 1395c-29 16-64 24-99 24zm-12901-446h12850l1921-948H3511l1918 948z"
          className="fil0"
        />
        <path
          d="M7447 15582H5838c-124 0-223-100-223-223v-967c0-124 99-223 223-223h1609c124 0 223 99 223 223v967c0 123-99 223-223 223zm-1386-446h1163v-522H6061v522zM17870 15582h-1609c-123 0-223-100-223-223v-967c0-124 100-223 223-223h1609c124 0 224 99 224 223v967c0 123-100 223-224 223zm-1386-446h1163v-522h-1163v522z"
          className="fil0"
        />
        <path
          d="M18330 14614H5376c-35 0-68-8-100-24l-2823-1394c-94-45-143-150-118-250 24-102 112-172 217-172h18602c104 0 193 73 217 172 24 102-27 205-118 250l-2824 1394c-29 16-64 24-99 24zm-12901-445h12850l1921-949H3508l1921 949z"
          className="fil0"
        />
        <path
          d="M7447 13220H5838c-124 0-223-99-223-223v-967c0-123 99-223 223-223h1609c124 0 223 100 223 223v967c0 124-99 223-223 223zm-1386-446h1163v-521H6061v521zM17870 13220h-1609c-123 0-223-99-223-223v-967c0-123 100-223 223-223h1609c124 0 224 100 224 223v967c0 124-100 223-224 223zm-1386-446h1163v-521h-1163v521z"
          className="fil0"
        />
        <path
          d="M18330 12253H5376c-35 0-68-8-100-24l-2823-1394c-94-46-143-151-118-250 24-102 112-172 217-172h18602c104 0 193 72 217 172 24 102-27 204-118 250l-2824 1394c-29 16-64 24-99 24zm-12901-446h12850l1921-948H3508l1921 948z"
          className="fil0"
        />
        <path
          d="M7447 10859H5838c-124 0-223-100-223-223v-967c0-124 99-223 223-223h1609c124 0 223 99 223 223v967c0 123-99 223-223 223zm-1386-446h1163v-521H6061v521zM17870 10859h-1609c-123 0-223-100-223-223v-967c0-124 100-223 223-223h1609c124 0 224 99 224 223v967c0 123-100 223-224 223zm-1386-446h1163v-521h-1163v521z"
          className="fil0"
        />
        <path
          d="M18330 9892H5376c-35 0-68-8-100-24L2453 8473c-94-45-143-150-118-250 24-102 112-171 217-171h18602c104 0 193 72 217 171 24 103-27 205-118 250l-2824 1395c-29 16-64 24-99 24zM5429 9446h12850l1921-949H3508l1921 949z"
          className="fil0"
        />
        <path
          d="M7447 8497H5838c-124 0-223-99-223-222v-968c0-123 99-223 223-223h1609c124 0 223 100 223 223v968c0 123-99 222-223 222zm-1386-445h1163v-522H6061v522zM17870 8497h-1609c-123 0-223-99-223-222v-968c0-123 100-223 223-223h1609c124 0 224 100 224 223v968c0 123-100 222-224 222zm-1386-445h1163v-522h-1163v522z"
          className="fil0"
        />
        <path
          d="M18330 7530H5376c-35 0-68-8-100-24L2453 6112c-94-46-143-151-118-250 24-102 112-172 217-172h18602c104 0 193 73 217 172 24 102-27 204-118 250l-2824 1394c-29 16-64 24-99 24zM5429 7084h12850l1921-948H3508l1921 948z"
          className="fil0"
        />
        <path
          d="M7447 6136H5838c-124 0-223-99-223-223v-967c0-124 99-223 223-223h1609c124 0 223 99 223 223v967c0 124-99 223-223 223zm-1386-446h1163v-521H6061v521zM17870 6136h-1609c-123 0-223-99-223-223v-967c0-124 100-223 223-223h1609c124 0 224 99 224 223v967c0 124-100 223-224 223zm-1386-446h1163v-521h-1163v521z"
          className="fil0"
        />
        <path
          d="M18330 5169H5376c-35 0-68-8-100-24L2453 3750c-94-45-143-150-118-250 24-102 112-171 217-171h18602c104 0 193 72 217 171 24 103-27 205-118 250l-2824 1395c-29 16-64 24-99 24zM5429 4723h12850l1921-949H3508l1921 949z"
          className="fil0"
        />
        <path
          d="M7447 3774H5838c-124 0-223-99-223-222v-968c0-123 99-223 223-223h1609c124 0 223 100 223 223v968c0 123-99 222-223 222zm-1386-445h1163v-522H6061v522zM17870 3774h-1609c-123 0-223-99-223-222v-968c0-123 100-223 223-223h1609c124 0 224 100 224 223v968c0 123-100 222-224 222zm-1386-445h1163v-522h-1163v522z"
          className="fil0"
        />
        <path
          d="M18330 2807H5376c-35 0-68-8-100-24L2453 1389c-94-46-143-150-118-250 24-102 112-172 217-172h18602c104 0 193 73 217 172 24 102-27 204-118 250l-2824 1394c-29 16-64 24-99 24zM5429 2361h12850l1921-948H3508l1921 948z"
          className="fil0"
        />
        <path
          d="M7447 1413H5838c-124 0-223-99-223-223V223c0-123 99-223 223-223h1609c124 0 223 100 223 223v967c0 124-99 223-223 223zM6061 967h1163V446H6061v521zM17870 1413h-1609c-123 0-223-99-223-223V223c0-123 100-223 223-223h1609c124 0 224 100 224 223v967c0 124-100 223-224 223zm-1386-446h1163V446h-1163v521z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
